module.exports = __webpack_public_path__ + "img/account-summary.aa8e5ff1.svg";